import React from 'react';

// atoms
import Text from '../../atoms/text';
import Subtitle from '../../atoms/subtitle';
import Button from '../../atoms/button';

// molecules
import StoreBadges from '../../molecules/storeBadges';

// style
import './style.scss';

export default () => {
  return (
    <>
      <div className="devices">
        <img src="../img/devices3.png" alt="Acesse de qualquer dispositivo" />
      </div>
      <Subtitle>
        Boa notícia,
        <br />
        você já é assinante de GZH!
      </Subtitle>
      <Text>
        O nosso período de teste é para os não assinantes experimentarem um
        pouquinho das vantagens que você já tem.
      </Text>
      <Button to="https://gauchazh.clicrbs.com.br/" external>
        Acessar GZH
      </Button>
      <StoreBadges />
    </>
  );
};
